<div class="flex flex-col dropdown-host" #cardTrigger>

    <!-- Card trigger -->
    <div
        class="card-input flex items-center text-xs py-2 dropdown-card"
        [class.select-active]="isOpen()"
        [class.has-error]="hasError"
        [class.is-disabled]="disabled"
        (click)="toggleDropdown()"
    >
        <!-- Label + sublabel block -->
        <div
            *ngIf="label"
            class="flex flex-col flex-shrink-0 justify-center"
            [style.width]="labelWidth"
        >
        <span class="text-xs font-semibold leading-tight">{{ label }}</span>
            <span *ngIf="subLabel" class="sub-label leading-tight mt-0.5">
                {{ subLabel }}
            </span>
        </div>

        <!-- Display value + arrow -->
        <div class="flex justify-between items-center h-30-px cursor-pointer w-full min-w-0">
            <span
                class="barlow text-xs pl-3 truncate min-w-0"
                [class.placeholder-color]="!displayText"
            >
                {{ displayText || placeholder }}
            </span>
            <span [ngClass]="arrowClass()" class="material-icons flex-shrink-0">
                {{ arrowIcon() }}
            </span>
        </div>
    </div>

    <!-- Error message -->
    <span
        class="font-semibold mt-1 error-msg"
        style="font-size: 10px;"
        *ngIf="showError && !isOpen() && errorMessage"
    >
        {{ errorMessage || 'This field is required.' }}
    </span>
    </div>

    <!-- Panel — teleported to body via CDK overlay -->
    <ng-template #dropdownPanel>
        <div class="checklist-panel" [class.select-active]="isOpen()" role="listbox">

            <!-- Default / All option -->
            <div
                *ngIf="showDefaultOption"
                class="checklist-item"
                [class.active]="defaultChecked"
                (click)="$event.stopPropagation(); defaultChecked = !defaultChecked; onDefaultChange()"
            >
                <span class="custom-radio" [class.checked]="defaultChecked"></span>
                <span class="item-label">{{ defaultOptionLabel }}</span>
            </div>

            <!-- Individual options -->
            <div
                *ngFor="let option of getValidOptions()"
                class="checklist-item"
                [class.active]="isOptionChecked(option.value!)"
                [class.is-disabled-option]="option.disabled"
                (click)="$event.stopPropagation(); onOptionChange(option.value!)"
            >
                <span class="custom-radio" 
                    [class.checked]="isOptionChecked(option.value!)"
                >
                </span>
                <span class="item-label">{{ option.label }}</span>
            </div>

        </div>
    </ng-template>